import { ClipType } from '@air/api/types';

/** Exhaustive so a new `ClipType` is a compile error rather than a silently unrecognised pill attr. */
const WORKSPACE_AGENT_ASSET_CLIP_TYPES: Record<ClipType, true> = {
  [ClipType.animated]: true,
  [ClipType.audio]: true,
  [ClipType.livePhoto]: true,
  [ClipType.nonMedia]: true,
  [ClipType.photo]: true,
  [ClipType.video]: true,
};

/** Narrows an unvalidated pill attr: an unknown string reads as no type at all. */
export const isWorkspaceAgentAssetClipType = (value: unknown): value is ClipType =>
  typeof value === 'string' && Object.hasOwn(WORKSPACE_AGENT_ASSET_CLIP_TYPES, value);
